function UserPerGroup({ user }) {
  const document = String(user?.document ?? user?.dni ?? '-').trim() || '-';
  const fullName =
    String(user?.full_name ?? user?.fullName ?? user?.name ?? '-').trim() || '-';

  return (
    <tr className='beneficiary-row'>
      <td className='beneficiary-cell beneficiary-cell--document'>{document}</td>
      <td className='beneficiary-cell beneficiary-cell--name'>{fullName}</td>
    </tr>
  );
}

export default UserPerGroup;
